import React from 'react';
import styled from 'styled-components';
import { ControlButtons } from './ControlButtons';
const ControlsWrapper = styled.div `
  width: 100%;
  height: 100%;
  .hover {
    display: flex;
  }
  .no-hover {
    display: none;
  }
  @media (hover: none) {
    .hover {
      display: none;
    }
    .no-hover {
      display: flex;
    }
  }
`;
const getButtonsWidth = (vertical, includeSound, hasHover) => {
    if (vertical || !includeSound) {
        if (hasHover) {
            return '56px';
        }
        return '72px';
    }
    if (hasHover) {
        return '96px';
    }
    return '128px';
};
const ControlButtonsWrapper = styled.div `
  // parent wrapper of the buttons so they fit to the video screen
  display: flex;
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  --buttons-width-hover: ${({ vertical, includeSound }) => getButtonsWidth(vertical, includeSound, true)};
  --buttons-width-no-hover: ${({ vertical, includeSound }) => getButtonsWidth(vertical, includeSound, false)};

  .buttons {
    // sets up the buttons to either be stacked in top right corner
    // or in row in bottom right corner
    position: absolute;
    display: flex;
    gap: 8px;
    padding: 12px;
    box-sizing: border-box;
    flex-direction: ${({ vertical }) => (vertical ? 'column' : 'row')};
    // this puts the buttons in the far end corner
    // which is right for ltr and left for rtl
    // 56px is the width of buttons on vertical
    // 96px is the width of buttons on horizontal
    margin-inline-start: calc(100% - var(--buttons-width-hover));
    @media (hover: none) {
      margin-inline-start: calc(100% - var(--buttons-width-no-hover));
    }
  }
`;
export const FullControls = ({ vertical, includeSound, colorSet, isPlaying, isMuted, togglePlay, toggleVolume, disabled, }) => {
    const controlButtonsProps = {
        isPlaying,
        isMuted,
        colorSet,
        togglePlay,
        toggleVolume,
        includeSound,
    };
    return (React.createElement(ControlsWrapper, { tabIndex: -1 },
        React.createElement(ControlButtonsWrapper, { className: "hover", vertical: vertical, tabIndex: -1, includeSound: includeSound },
            React.createElement("div", { className: "buttons" },
                React.createElement(ControlButtons, Object.assign({}, controlButtonsProps, { disabled: disabled })))),
        React.createElement(ControlButtonsWrapper, { className: "no-hover", vertical: vertical, includeSound: includeSound },
            React.createElement("div", { className: "buttons" },
                React.createElement(ControlButtons, Object.assign({}, controlButtonsProps, { useMediumButtons: true, disabled: disabled }))))));
};
//# sourceMappingURL=FullControls.js.map